/**
 * DisplayControl — the always-visible CRT button in the player chrome.
 *
 * Per spec clarification Q1: organic discovery via a persistent small
 * button with a CRT-tube glyph. No timed nudges, no banners.
 *
 * Supports a disabled state with an explanatory tooltip for devices
 * that cannot drive the CRT layer (FR-019a).
 */

export interface DisplayControlProps {
  active: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  onToggle: () => void;
  loading?: boolean;
}

export function DisplayControl({
  active,
  disabled,
  disabledTooltip,
  onToggle,
  loading,
}: DisplayControlProps) {
  return (
    <button
      className={`display-control${active ? " active" : ""}`}
      onClick={disabled ? undefined : onToggle}
      disabled={disabled || loading}
      title={disabled ? disabledTooltip : active ? "Turn CRT off" : "Watch on a real TV"}
      aria-label={disabled ? disabledTooltip : active ? "Turn CRT off" : "Watch on a real TV"}
      aria-pressed={active}
      style={{
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? "default" : "pointer",
      }}
    >
      {/* CRT tube glyph — a simple SVG monitor shape */}
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
      {loading && <span style={{ marginLeft: "0.3rem", fontSize: "0.75rem" }}>…</span>}
    </button>
  );
}
